// The auth layout (FR-042, FR-047; research R14): the no-school product header (001 FR-027) above one
// centred card, max width 440 on the web, full width with 16 px margins on phones; heading Poppins
// 600 24 px. Scrolls when the keyboard or a small screen needs it.
import type { ReactNode } from "react";
import { ScrollView, StyleSheet, View } from "react-native";

import { ProductHeader } from "@/shell/header/ProductHeader";
import { makeStyles } from "@/theme/makeStyles";
import { Text } from "@/ui/Text";

/** The card's maximum width on the web (research R14). */
export const AUTH_CARD_MAX_WIDTH = 440;

const useStyles = makeStyles((t) =>
  StyleSheet.create({
    screen: { flex: 1, backgroundColor: t.color.background },
    scroll: {
      flexGrow: 1,
      alignItems: "center",
      paddingHorizontal: t.space.lg,
      paddingVertical: t.space.x2l,
    },
    card: {
      width: "100%",
      maxWidth: AUTH_CARD_MAX_WIDTH,
      backgroundColor: t.color.surface,
      borderColor: t.color.border,
      borderWidth: t.borderWidth.card,
      borderRadius: t.radius.card,
      padding: t.space.x2l,
      gap: t.space.lg,
      boxShadow: t.shadow.card,
    },
  }),
);

export type AuthCardProps = {
  title: string;
  children: ReactNode;
  testID?: string;
};

export function AuthCard({ title, children, testID }: AuthCardProps) {
  const styles = useStyles();
  return (
    <View style={styles.screen} testID={testID}>
      <ProductHeader />
      <ScrollView
        contentContainerStyle={styles.scroll}
        keyboardShouldPersistTaps="handled"
        role="main"
        testID={testID ? `${testID}-scroll` : undefined}
      >
        <View style={styles.card}>
          <Text
            variant="heading"
            weight="semiBold"
            size="x3l"
            accessibilityRole="header"
            aria-level={1}
          >
            {title}
          </Text>
          {children}
        </View>
      </ScrollView>
    </View>
  );
}
